export const ADD_CARRIERS_TO_PROJECT_OPTIONS = {
	ADD_ALL: 'Add all carriers to the Project',
	ADD_WITH_MORE_THAN_1_LOADS: 'Add all carriers that ran more than 1 loads',
	ADD_WITH_MORE_THAN_5_LOADS: 'Add all carriers that ran more than 5 loads',
};
